module.exports = __webpack_public_path__ + "static/media/stackoverflow-512.caaa8a7a.png";